module.exports = __webpack_public_path__ + "static/media/RainierLessCompressed.fb1aea3d.jpg";